import * as vp from 'vopay';

import { useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useRailzVendors() {
    const source = axios.CancelToken.source();

    const [vendors, setVendors] = useState<vp.RailzVendor[]>();

    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const fetchVendors = async (requestParams: vp.RailzVendorsRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.railzVendors(requestParams, source);
        setVendors(res.Vendors);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };
    const reset = () => {
      setVendors(undefined);
    };

    return {
      vendors,
      fetchVendors,
      reset,
    };
  };
});

export default initHook({});
